import { extendTheme } from "@chakra-ui/react";
import { localizeTheme } from "./utils/fontUtils.js";
import components from "./components/index.js";
import colors from "./colors.js";
import sizes from "./sizes.js";
import styles from "./styles.js";
import typography from "./typography.js";
import shadows from "./shadows.js";
import radii from "./radiuses.js";
const theme = extendTheme({
    colors,
    components,
    sizes,
    styles,
    shadows,
    radii,
    ...typography,
});
export { theme, localizeTheme };
